import React from 'react';
import './isi.scss';
import IsiButton from './IsiButton';
import IsiBody from './IsiBody';

function IsiModal({ isOpen, setIsOpen, modalRef }) {
  return (
    <section className={isOpen ? 'isi__modal  isi__modal--open' : 'isi__modal'} ref={modalRef}>
      <div className={isOpen ? 'isi__wrapper  isi__wrapper--open' : 'isi__wrapper'}>
        <IsiButton isOpen={isOpen} setIsOpen={setIsOpen} origin={'modal'} />
        <IsiBody origin={'modal'} />
      </div>
    </section>
  );
}

export default IsiModal;
